import router from "@/router/index";
import $store from '../store';
import axios from 'axios';
import { Capacitor } from '@capacitor/core';
import { AuthService } from '../services/auth.service';
import { isHashOnlyChange } from './util';

export async function cachePreviousPath(to, from, next) {
  router.from = from;
  next();
}

// Rotas que dependem de funcionalidades nativas (filesystem offline, plugin de
// download). Acesso via browser web cai pra /p/my-courses — sem isso, o user
// veria uma página intencionalmente quebrada (state vazio, sem origem dos dados).
export function checkNativeOnlyMiddleware(to, from, next) {
  const nativeOnly = to.matched.some(item => item.meta.nativeOnly);
  if (nativeOnly && !Capacitor.isNativePlatform()) {
    return next({ name: 'my-courses' });
  }
  next();
}

/**
 * Check access permission to auth routes
 */
function _nextFromCache(next) {
  try {
    const cached = JSON.parse(localStorage.getItem('ead_cached_user') || 'null');
    if (cached && cached.studentId) {
      $store.commit('user/SET_CURRENT_USER', cached);
      return next();
    }
  } catch {}
  return next({ name: 'login' });
}

export function checkAccessMiddleware(to, from, next) {
  const isAuthRoute = to.matched.some(item => item.meta.isAuth);
  if (!isAuthRoute) return next();

  const currentUserId = $store.state.user.currentUser.studentId;

  // Só o hash mudou (deep link de comentário, salto de tempo, o replace que os
  // limpa): mesma tela e o usuário já carregado. Esperar o GET do sino aqui
  // atrasava a navegação, e o scrollBehavior rodava depois da rolagem da aula.
  if (currentUserId && isHashOnlyChange(to, from)) return next();

  // Offline: nunca faz chamadas de rede
  if (!$store.state.dom.isConnected) {
    let hasUser = Boolean(currentUserId);

    if (!hasUser) {
      try {
        const cached = JSON.parse(localStorage.getItem('ead_cached_user') || 'null');
        if (cached && cached.studentId) {
          $store.commit('user/SET_CURRENT_USER', cached);
          hasUser = true;
        }
      } catch {}
    }

    if (!hasUser) return next({ name: 'login' });

    // Carrega matrículas do offlineStorage (o action já trata isso internamente)
    $store.dispatch('enroll/getUserEnroll');
    return next();
  }

  // Online: usuário já carregado nesta sessão
  if (currentUserId) {
    // Polling do sino (idempotente). Quem entra pelo boot com sessão viva não
    // passa pelas telas de login, que eram as únicas a ligá-lo.
    $store.dispatch('notification/initLoopTimeout');
    $store.dispatch('notification/getNotifications')
      .then(() => next())
      .catch(() => next()); // notificações são opcionais, não travam a navegação
    return;
  }

  var accessToken = AuthService.getAccessToken();
  if (!accessToken) return next({ name: 'login' });

  AuthService.startKeepAlive();
  axios.defaults.headers.common['authorization'] = `bearer ${accessToken}`;

  var getUserInfo = $store.dispatch('user/getCurrent').then(() => $store.dispatch('config/getConfig'));
  var getUserEnroll = $store.dispatch('enroll/getUserEnroll');
  var getNotifications = $store.dispatch('notification/getNotifications');
  $store.dispatch("subscription/getUserSubscriptions");

  $store.dispatch('notification/initLoopTimeout');

  Promise.all([getUserEnroll, getUserInfo, getNotifications])
    .then(() => next())
    .catch(() => _nextFromCache(next)); // APIs falharam: fallback para cache
}

export function setPageTitleMiddleware(to, from, next) {
  const pageTitle = to.matched.find(item => item.meta.title);

  if (pageTitle) window.document.title = pageTitle.meta.title;
  next();
}


export function resetChatbox(to, from, next) {
  if (!['class', 'course', 'trustflix'].includes(to.name)) {
    const bubbles = document.getElementsByTagName('chaindesk-chatbox-bubble');
    for (let bubble of bubbles)
      bubble.remove();

    if (window.ChatboxBubble) {
      delete window.ChatboxBubble;
      delete window.widget;
    }
    //precisa limpar o cache de lista de learningobjectsIds do redis aqui tbm
  }

  next();
}
